/**
 * @generated SignedSource<<db4e70fde94392a87f73ffcdf97591d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pickerContent_autodevAgentPicker_agentsFragRef$data = {
  readonly devai_autodevRovoAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null | undefined;
        readonly externalConfigReference: string | null | undefined;
        readonly id: string;
        readonly identityAccountId: string | null | undefined;
        readonly name: string;
      };
    } | null | undefined>;
  } | null | undefined;
  readonly devai_autodevRovoTemplates?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "pickerContent_autodevAgentPicker_agentsFragRef";
};
export type pickerContent_autodevAgentPicker_agentsFragRef$key = {
  readonly " $data"?: pickerContent_autodevAgentPicker_agentsFragRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};

import pickerContentRefetchQuery_graphql from './pickerContentRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchStr"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": pickerContentRefetchQuery_graphql
    }
  },
  "name": "pickerContent_autodevAgentPicker_agentsFragRef",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "first",
              "value": 20
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "searchStr"
            }
          ],
          "concreteType": "DevAiRovoAgentConnection",
          "kind": "LinkedField",
          "name": "devai_autodevRovoAgents",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "DevAiRovoAgent",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          "action": "THROW",
                          "path": "devai_autodevRovoAgents.edges.node.name"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v1/*: any*/),
                          "action": "THROW",
                          "path": "devai_autodevRovoAgents.edges.node.id"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "description"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "identityAccountId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "externalConfigReference"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "devai_autodevRovoAgents.edges.node"
                  }
                ]
              },
              "action": "THROW",
              "path": "devai_autodevRovoAgents.edges"
            }
          ]
        },
        {
          "alias": "devai_autodevRovoTemplates",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Literal",
              "name": "templatesFilter",
              "value": "ONLY"
            }
          ],
          "concreteType": "DevAiRovoAgentConnection",
          "kind": "LinkedField",
          "name": "devai_autodevRovoAgents",
          "plural": false,
          "selections": [
            {
              "concreteType": "DevAiRovoAgentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "DevAiRovoAgent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "a783691b6b3a08e13301d1198429425b";

export default node;
